export default __webpack_public_path__ + "static/media/U_Uva.85d3ab25.mp3";